import { Pagination, PaginationInfo, paginationInfo } from "@robe/core-utils";

export type PaginationParsed = Omit<Pagination, "perPage"> | null;

export const DEFAULT_PAGINATION = 50;

export const pagination = (perPage: number, core: { query: Record<string, string | string[]> }) => ({
  perPage,
  page: Number(core.query.page),
});

export const limit = (perPage: number, query: Record<string, string | string[]>) => ({
  page: 1,
  perPage: perPage * Number(query.page ?? 1),
});

export const resolvePagination = (
  paginate: PaginationParsed,
  perPage: number | undefined
): {
  pagination?: PaginationInfo | undefined;
} => ({
  ...(paginate && {
    pagination: paginationInfo({
      ...paginate,
      perPage: perPage ?? DEFAULT_PAGINATION,
    }),
  }),
});

export const parseRangeHeader = (header: string): Omit<Pagination, "perPage"> => {
  const [_, from, to, end] = header ? ([...header.matchAll(/items (\d+)-(\d+)\/(\d+)/g)][0] as string[]) : [];
  return { from: +from, to: +to, end: +end };
};

export const paginateRes = async (res: Response): Promise<[any, PaginationParsed]> => {
  const contentRange = res.headers.get("content-range");
  return await res.json().then((x) => [x, contentRange ? parseRangeHeader(contentRange!) : null]);
};
